import React from 'react';
import { User, Mail, Phone } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';

interface BasicInfoData {
  name: string;
  email: string;
  phone: string;
}

interface BasicInfoProps {
  data: BasicInfoData;
  onChange: (data: BasicInfoData) => void;
}

const BasicInfo = ({ data, onChange }: BasicInfoProps) => {
  const { t } = useLanguage();
  
  return (
    <div className="space-y-6">
      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t('candidates.addCandidateModal.basicInfo.fullName')}
        </label>
        <div className="relative">
          <input
            type="text"
            value={data.name}
            onChange={(e) => onChange({ ...data, name: e.target.value })}
            className="w-full pl-10 pr-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-blue-500 transition-shadow"
            placeholder={t('candidates.addCandidateModal.basicInfo.fullNamePlaceholder')}
            required
          />
          <User className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
        </div>
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t('candidates.addCandidateModal.basicInfo.emailAddress')}
        </label>
        <div className="relative">
          <input
            type="email"
            value={data.email}
            onChange={(e) => onChange({ ...data, email: e.target.value })}
            className="w-full pl-10 pr-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-blue-500 transition-shadow"
            placeholder={t('candidates.addCandidateModal.basicInfo.emailPlaceholder')}
            required
          />
          <Mail className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
        </div>
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t('candidates.addCandidateModal.basicInfo.phoneNumber')}
        </label>
        <div className="relative">
          <input
            type="tel"
            value={data.phone}
            onChange={(e) => onChange({ ...data, phone: e.target.value })}
            className="w-full pl-10 pr-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-blue-500 transition-shadow"
            placeholder={t('candidates.addCandidateModal.basicInfo.phonePlaceholder')}
          />
          <Phone className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;